import { Injectable, inject } from '@angular/core';
import { SendTemplateEmailRequest } from '../interfaces/send-template-email-request';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaEmailApi {
  private api = inject(SiaHttpService);

  private apiController: string = 'system-email';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  sendWithTemplate(payload: SendTemplateEmailRequest): Promise<boolean> {
    return this.api.post(`${this.apiController}/send-with-template`, payload);
  }
}
